if (!customElements.get('ib-deferred-app')) {
  customElements.define('ib-deferred-app', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        const template = this.querySelector('template');
        if (!template) return;
        const content = template.content.cloneNode(true);
        const scripts = [...content.querySelectorAll('script')];
        scripts.forEach(script => script.remove());
        this.append(content);
        template.remove();
        scripts.forEach(original => {
          const script = document.createElement('script');
          for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
          script.textContent = original.textContent;
          this.append(script);
        });
      }, {rootMargin: '300px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.started = false; }
  });
}
